export default __webpack_public_path__ + "static/media/theme-check-blue.32f312ac.svg";